import {Component, Input, OnInit} from '@angular/core';
import {NgClass, NgIf} from '@angular/common';
import {AccountEventVoucher} from '../../models/AccountEvent';
import {Router} from '@angular/router';
import {TranslateService} from '../../services/translate.service';
import { ReceiptDetailsMobileVoucher } from '../../models/ReceiptDetails';
import MoneyUtils from '../../utils/Utils';
import { SlideToActivateComponent } from './slide-to-activate.component';

  @Component({
    selector: 'app-dragger',
    standalone: true,
    template: `
      <div class="flex items-start">
        <i class="fas fa-ticket fa-2x mr-2"></i>
        <span class="flex flex-col">
          <span *ngIf="type==='feed'" class="font-bold text-xl">{{getString(name)}}</span>
          <span *ngIf="price" class="text-lg font-medium">{{price}}</span>
        </span>
      </div>
      <div class="mt-3 mx-1" *ngIf="message">{{message}}</div>
      <div *ngIf="type!=='feed'" class="font-bold">{{getString(name)}}</div>
      <div class="mt-4 mb-6">
        <app-slide-to-activate
          [text]="getString('Aktivera 1 min')"
          [consumedText]="getString('Förbrukad')"
          [isConsumed]="voucher.consumed"
          (activated)="onSliderActivated()">
        </app-slide-to-activate>
      </div>
    `,
    imports: [
      NgClass,
      NgIf,
      SlideToActivateComponent
    ]
  })
export class DraggerComponent implements OnInit  {
  @Input() voucher!: AccountEventVoucher | ReceiptDetailsMobileVoucher;
  @Input() venueId!: number;
  @Input() type!: string;
  @Input() price: string|null = null;
  name!: string;
  message!: string;

  constructor(private router: Router, private translate: TranslateService) { }

  ngOnInit(): void {
    this.name = this.voucher.name.replace("§§§", "").replace(/\|/g, ", ");
    this.message = this.voucher.message;
  }

  onSliderActivated() {
    this.router.navigateByUrl(`${this.venueId}/glance/${this.voucher.id}`, { skipLocationChange: true });
  }

  getString(s: string, pc: string = "normal") {
    return this.translate.single(s, pc);
  }

}
